var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9497 9.46447C18.3403 9.07394 18.3403 8.44078 17.9497 8.05025C17.5592 7.65973 16.9261 7.65973 16.5355 8.05025L17.9497 9.46447ZM8.05025 16.5355C7.65973 16.9261 7.65973 17.5592 8.05025 17.9497C8.44078 18.3403 9.07394 18.3403 9.46447 17.9497L8.05025 16.5355ZM16.5355 17.9497C16.9261 18.3403 17.5592 18.3403 17.9497 17.9497C18.3403 17.5592 18.3403 16.9261 17.9497 16.5355L16.5355 17.9497ZM9.46447 8.05025C9.07394 7.65973 8.44078 7.65973 8.05025 8.05025C7.65973 8.44078 7.65973 9.07394 8.05025 9.46447L9.46447 8.05025ZM24 13C24 19.0751 19.0751 24 13 24V26C20.1797 26 26 20.1797 26 13H24ZM13 24C6.92487 24 2 19.0751 2 13H0C0 20.1797 5.8203 26 13 26V24ZM2 13C2 6.92487 6.92487 2 13 2V0C5.8203 0 0 5.8203 0 13H2ZM13 2C19.0751 2 24 6.92487 24 13H26C26 5.8203 20.1797 0 13 0V2ZM16.5355 8.05025L12.2929 12.2929L13.7071 13.7071L17.9497 9.46447L16.5355 8.05025ZM12.2929 12.2929L8.05025 16.5355L9.46447 17.9497L13.7071 13.7071L12.2929 12.2929ZM17.9497 16.5355L13.7071 12.2929L12.2929 13.7071L16.5355 17.9497L17.9497 16.5355ZM13.7071 12.2929L9.46447 8.05025L8.05025 9.46447L12.2929 13.7071L13.7071 12.2929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f1e0b102484d9970d64c6904d1b84a89.svg";
export { ForwardRef as ReactComponent };